import { OperatorFunction, take } from 'rxjs';
import { filterNil } from './filter-null';

/**
 * Filter null or undefied, and take 1.
 */
export function current<T>(): OperatorFunction<T | null | undefined, T> {
  return (source) => source.pipe(filterNil(), take(1));
}
